import React from 'react';
import { Badge, DetailsCardHeader, Grid, Link, Text } from '@tq/ui-components';

import { PUBLIC_REGISTER_APPLICATION_URL } from 'config';
import { RelatedApplicationResponse } from 'types';

type RelatedApplicationCardHeaderProps = {
  relatedCase: RelatedApplicationResponse;
};

export const RelatedApplicationCardHeader: React.FC<RelatedApplicationCardHeaderProps> = ({
  relatedCase,
}) => {
  const FIRST_ROW_TEMPLATE = `
    "link status" 
    / auto auto`;

  const getPublicRegisterUrl = (arn: string): string =>
    `${PUBLIC_REGISTER_APPLICATION_URL}${arn?.replaceAll('/', '_')}`;
  const addressToDisplay = relatedCase?.singleLineOfAddress ?? relatedCase?.address?.address;

  return (
    <>
      <DetailsCardHeader display='block' pb={0}>
        <Grid
          gridGap={2}
          gridTemplate={FIRST_ROW_TEMPLATE}
          gridTemplateColumns={`75% 25%`}
          gridAutoFlow='column'
          justifyContent='space-between'
        >
          {relatedCase.applicationTypeCategory === 'Planning' ? (
            <Link
              target='_blank'
              href={getPublicRegisterUrl(relatedCase?.relatedApplicationReferenceNumber)}
            >
              {addressToDisplay}
            </Link>
          ) : (
            <Text fontWeight='bold'>{addressToDisplay}</Text>
          )}
          <Badge
            display='flex'
            alignItems='center'
            justifyContent='center'
            fontSize='sm'
            mr={0}
            color='black'
            bgColor='blue.100'
          >
            {relatedCase.applicationTypeCategory}
          </Badge>
        </Grid>
      </DetailsCardHeader>
    </>
  );
};
